<template>
  <el-table-column
    prop="name"
    sortable
    label="Név"
  >
    <template slot-scope="scope">
      {{ scope.row.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
